import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VTableModule } from "@app/directives/_layout/v-table/v-table.module";
import { ResourceFiltersDirectivesModule } from "@app/directives/_resourceFilters/_resourceFilters.directives.module";
import { ResellerSelectComponent } from "@app/main/modules/foundation/_components/reseller-selector/reseller-selector.component";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@directives/_forms/_form.directives.module";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { VeriTableService } from "@directives/_veri/veriTable/veriTable.service";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { CustomerNameComponent } from "@foundation/_components/customer-name/customer-name.component";
import { FoundationNotesListComponent } from "@foundation/_components/foundation-notes-list/foundation-notes-list.component";
import { SimStatusInfoComponent } from "@foundation/_components/simStatusInfo/simStatusInfo.component";
import { providerCreator } from "@services/_services.module";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { SimDataComponent } from "../_routes/hardware/sim/sim-data/sim-data.component";
import { SimStatusComponent } from "../_routes/hardware/sim/sim-status/sim-status.component";
import { FoundationPeripheralService } from "../_services/peripheral.service.ajs";
import { BarcodeScannerLivestreamComponent } from "./barcode-scanner/barcode-scanner-livestream.component";
import { BarcodeScannerComponent } from "./barcode-scanner/barcode-scanner.component";
import { CommandSenderComponent } from "./commandSender/commandSender.component";
import { CommissionCheckComponent } from "./commissionCheck/commission-check.component";
import { ConfigSwitcherComponent } from "./configSwitcher/config-switcher.component";
import { DeviceInstallValidatorComponent } from "./device-install-validator/device-install-validator.component";
import { DeviceSummaryComponent } from "./device-summary/device-summary.component";
import { DeviceValidationSummaryComponent } from "./device-validation-summary/device-validation-summary.component";
import { Commission4gCheckComponent } from "./diagnostics4G/commission4gCheck/commission-4g-check.component";
import { Diagnostics4gComponent } from "./diagnostics4G/diagnostics-4g.component";
import { FoundationAuditNotesListComponent } from "./notesAuditList/notes-audit-list.component";
import { ResellerNameComponent } from "./reseller-name/reseller-name.component";
import { ValidationCheckContainerComponent } from "./validation-check-container/validation-check-container.component";

const privateComponents: any[] = [

];

const publicComponents: any[] = [
    SimStatusInfoComponent,
    CustomerNameComponent,
    ResellerNameComponent,
    FoundationNotesListComponent,
    BarcodeScannerComponent,
    BarcodeScannerLivestreamComponent,
    CommandSenderComponent,
    ConfigSwitcherComponent,
    Diagnostics4gComponent,
    Commission4gCheckComponent,
    FoundationAuditNotesListComponent,
    DeviceSummaryComponent,
    SimDataComponent,
    SimStatusComponent,
    DeviceValidationSummaryComponent,
    DeviceInstallValidatorComponent,
    ValidationCheckContainerComponent,
    CommissionCheckComponent,
    ResellerSelectComponent
];

const declarations: any[] = [
];

const providers: any[] = [
    providerCreator(VeriTableService, "veriTableService"),
    providerCreator(FoundationPeripheralService, "foundationPeripheralService")
];

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        PipesModule,
        MiscDirectivesModule,
        LayoutDirectivesModule,
        VeriDirectivesModule,
        FormsModule,
        ReactiveFormsModule,
        CoreDirectivesModule,
        FormsDirectivesModule,
        VTableModule,
        ResourceFiltersDirectivesModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations]
})
export class FoundationComponentsModule {
    constructor() {
    }
}
